// modalController.ts
/*let showFn: null | ((params: any[],type: number, extraInfo: any) => void) = null;

export const modalController = {
    register(show: (params: any[], type: number,extraInfo: any) => void) {
        showFn = show;
    },
    show(params: any[],type: number,extraInfo: any) {
        if (showFn) showFn(params,type,extraInfo);
    }
};*/
let showFn: null | ((params: any[], type: number, extraInfo: any, resolve: (input: any) => void) => void) = null;
let resolver: ((input: any) => void) | null = null;

export const modalController = {
    register(show: typeof showFn) {
        showFn = show;
    },
    async show(params: any[], type: number, extraInfo: any): Promise<any> {
        return new Promise(resolve => {
            resolver = resolve;
            showFn?.(params, type, extraInfo, resolve);
        });
    },
    submit(input: any) {
        resolver?.(input);
        resolver = null;
    }
};